<template>

  <div class="blogs">
    <div v-if="blogPosts">
      <p class="lead">All blog posts ({{blogsCount}})</p>
      <div class="blog-list"v-for="(year, i) in years" v-bind:key="i">
        <label class="year"> <i class="far fa-calendar-alt"></i>&nbsp;&nbsp;{{year}}</label>
        <div class="row blog-row" v-for="(b, j) in blogPosts[year]" v-bind:key="j" v-on:click="gotoBlog(b.id)">
          <div class="col-md-6">
            <span class="title pull-left">
              <i class="fas fa-angle-double-right"></i>&nbsp;&nbsp;{{b.title}}
            </span>
          </div>
          <div class="col-md-6">
            <span class="pull-right">{{b.month + " " + b.day}}</span>
          </div>                  
        </div>     
      </div>
    </div>

    <div v-else>
      Loading...
    </div>
  </div>
        
</template>

<script>
export default {
  components: {},
  name: "BlogList",
  data() {
    return {
      blogsCount: 0,
      blogPosts: null,
      years: []
    };
  },
  methods: {
    gotoBlog(id) {
      this.$router.push({ path: "blogs/" + id });
    },

    formatPosts(posts) {
      // Seperate years and blogs, render according to sorted years
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      if (!posts) {
        return;
      }

      var blogPosts = {};
      for (var i = 0; i < posts.length; i++) {
        var b = posts[i];
        //format date
        var date = new Date(b.published);
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();

        //push year only one time
        if (this.years.indexOf(year) == -1) this.years.push(year);

        b["year"] = year;
        b["month"] = month;
        b["day"] = day;

        if (!blogPosts[year]) blogPosts[year] = [];
        blogPosts[year].push(b);
      }

      //sort in descending order
      this.years.sort(function(a, b) {
        return b - a;
      });
      this.blogsCount = posts.length;
      return blogPosts;
    }
  },
  computed: {},
  created() {
    console.log('created');
    var self = this;
    this.blogPosts = self.formatPosts(this.$store.state.blogs);
    if (!this.blogPosts) {
      this.$store.dispatch("getBlogs", function(blogPosts) {
        self.blogPosts = self.formatPosts(blogPosts);
        self.$store.commit('setBlogs', blogPosts); 
        self.$forceUpdate();       
      });
    }
  }
};
</script>


<style scoped>
.blogs {
  min-height: calc(100vh - 50px);
  padding: 50px;
  padding-top: 50px;
}

.blog-list {
  width: 100%;
  margin-top: 5px;
  padding: 10px !important;
  text-align: left;
  font-size: 15px !important;
}

.year {
  font-weight: bold;
  color: rgb(62, 143, 65);
  font-size: 20px;
}

.blog-row {
  margin: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  transition: padding-left 0.2s, color 0.5s;
}
.blog-row:hover {
  padding-left: 10px;
  color: green;
  cursor: pointer;
}

.link {
  color: #2e7d32;
  font-weight: bold;
}

.post-count {
  float: right;
  font-family: Segoe UI;
  color: green;
  font-weight: 600;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogList.vue